import { render, staticRenderFns } from "./insertLabels.vue?vue&type=template&id=6c99313f"
import script from "./insertLabels.vue?vue&type=script&lang=js"
export * from "./insertLabels.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../fe-workerportal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports